import React, {useContext} from 'react'
import AuthContext from '../context/AuthContext'

import { Link } from 'react-router-dom'

import '../assets/css/register.css'
import logo from '../assets/images/logo.jpeg'

const LoginPage = () => {
  let {loginUser} = useContext(AuthContext)
  return (
    <div className='container text-center mt-5'>
        {/* <form onSubmit={loginUser}>
            <input type="text" name="username" placeholder='Enter Username' />
            <input type="password" name="password" placeholder='Enter Password' />
            <input type="submit" />
        </form> */}

        <main className="form-signin col-lg-4 col-sm-12 m-auto">
            <form onSubmit={loginUser}>
                <img className="mb-4 mt-5" src={logo} alt="" width="75%" />
                <h1 className="h3 mb-3 fw-normal">Please Login</h1>

                <div className="form-floating mb-3">
                <input type="text" className="form-control" id="floatingInput1" placeholder="username" name='username' />
                <label htmlFor="floatingInput">Username</label>
                </div>
                <div className="form-floating mb-3">
                <input type="password" className="form-control" id="floatingPassword" placeholder="Password" name='password'/>
                <label htmlFor="floatingPassword">Password</label>
                </div>

                <input type="submit" className="w-100 btn btn-lg btn-primary" value="Login" />
                <p className="mt-2 mb-3 text-muted">Hamsie Expenses &copy; 2023</p>
            </form>
        </main>
    </div>
  )
}

export default LoginPage